import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { pdf } from "@react-pdf/renderer"; 
import patientService from "../../../Services/patientService";
import doctorService from "../../../Services/doctorService";
import PatientReport from "../PatientReport";
import logo from "../../../assets/logo3.png";
import saleService from "../../../Services/saleService";
import toast from "react-hot-toast";

const PatientDetails = () => {
  const { id } = useParams();
  const [doctor, setDoctor] = useState(null);
  const [patient, setPatient] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getPatientsDetails = async () => {
      try {
        setLoading(true);
        console.log("ID Passed:", id);
        const response = await saleService.fetchSale(id);

        console.log("API Response:", response); 
        console.log("Sale Data:", response.sale);

        if (response && response.sale) {
          const patientData = response.sale.find(
            (sale) => String(sale.sale_id).trim() === String(id).trim()
          );
          console.log("Matched Patient Data:", patientData); 

          if (patientData) {
            setPatient(patientData);
          } else {
            toast.error(`No patient data found for ID ${id}.`);
          }
        } else {
          toast.error("No sale data found.");
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error("Error fetching patient data.");
        console.error("Fetch Error:", error);
      }
    };

    getPatientsDetails();
  }, [id]); 

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString("en-US", options);
  };

  const handlePrint = async () => {
    const doc = <PatientReport patient={patient} doctor={doctor} />;
    const blob = await pdf(doc).toBlob();
    const url = URL.createObjectURL(blob);
    const newWindow = window.open(url, "_blank");
    if (newWindow) newWindow.print(); 
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!patient) {
    return <div>Patient data not available.</div>;
  }

  const calculateAge = (dateOfBirth) => {
    if (!dateOfBirth) return "N/A";
    const birthDate = new Date(dateOfBirth);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  };

  return (
    <div className="max-w-5xl mx-auto p-4 bg-gray-100">
      <div className="flex justify-between items-center border-b-2 pb-4 mb-3">
        <div className="flex items-center space-x-4">
          <img src={logo} alt="Logo" className="w-16 h-15" />
        </div>
        <div className="flex flex-col items-center space-x-4">
          <h1 className="text-2xl font-bold">
            Hospital Management System
          </h1>
          <p className="text-sm"> Lahore</p>
        </div>
        <div className="text-right">
          <p className="text-sm">{formatDate(patient?.sale_date)}</p>
          <p className="text-sm">{patient.doctor_name}</p>
          <p className="text-sm">{patient.specialization}</p>
          <p className="text-sm">{patient.qualification}</p>

          <p className="text-lg font-semibold">
            Patient No: {patient.patient_id}
          </p>
        </div>
      </div>

      <div className="mb-2">
        <h2 className="text-xl font-semibold">
          Patient:{" "}
          {patient?.patient_name
            ?.split(" ")
            .map(
              (word) =>
                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            )
            .join(" ")}
        </h2>
      </div>

      <div className="mb-2">
        <table className="table-auto w-full border-collapse border border-gray-200 items-center box-border">
          <tbody>
            <tr>
              <td className="border border-gray-300 p-2 ">Age</td>
              <td className="border border-gray-300 p-2 ">
                {patient.age || calculateAge(patient.date_of_birth)}
              </td>
              <td className="border border-gray-300 p-2 ">Gender</td>
              <td className="border border-gray-300 p-2 ">
                {patient.gender || "Male"}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="font-semibold mt-3 mb-3">
        <div>Temp:</div>
        <div>Blood Pressure:</div>
        <div>Pulse Rate</div>
      </div>

      <hr className="border-gray-300 mt-3" />

      <div className="flex">
        <div className="w-1/5 border-r-2 pr-4">
          <div className="mb-6">
            <h3 className="text-lg font-bold">History</h3>
            <p className="mt-2 text-sm">
              {patient.history || (
                <>
                  <br />
                  <br />
                </>
              )}
            </p>
          </div>
          <div className="mb-6">
            <h3 className="text-lg font-bold">Diagnose:</h3>
            <p className="mt-2 text-sm">
              {patient.diagnosis || (
                <>
                  <br />
                  <br />
                </>
              )}
            </p>
          </div>
          <div className="mb-6">
            <h3 className="text-lg font-bold">Recommendation:</h3>
            <p className="mt-2 text-sm">
              {patient.recommendation || (
                <>
                  <br />
                  <br />
                </>
              )}{" "}
            </p>
          </div>
        </div>
        <div className="w-4/5 pl-4">
          <div className="mb-6">
        
            <p className="mt-2 text-sm">
              {patient.treatment_recommendation || (
                <>
                  <br />
                  <br />
                </>
              )}{" "}
            </p>
          </div>
        </div>
      </div>

      <div className="mt-10 flex justify-center">
        <button
          onClick={handlePrint}
          className="px-4 py-2 bg-gray-600 text-white rounded shadow hover:bg-gray-700 fixed bottom-4 transform -translate-x-1/2 "
        >
          Print PDF
        </button>
      </div>
    </div>
  );
};

export default PatientDetails;
